import { ReactNode } from "react";

export type MaintenanceSectionHeaderProps = {
  title?: string,
  subtitle?: string,
  children?: ReactNode,
  noMargin?: boolean,
}

export const MaintenanceSectionHeader = ({ title, subtitle, children, noMargin }: MaintenanceSectionHeaderProps) => {
  return (
    <div className="w-full">
      <div className={`border-b border-[#ddd] py-2.5 bg-transparent ${noMargin ? "" : "mb-3.25"}`.trim()}>
        {/* Only split into columns when there are actions to place on the right, so the
            title and subtitle get the full width instead of wrapping at half. */}
        <div className={children ? "grid grid-cols-2 gap-0" : ""}>
          <div className="align-middle content-center">
            <p className="text-lg font-semibold text-gray-600">{title}</p>
            {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
          </div>
          {children && <div className="flex justify-end gap-x-3">{children}</div>}
        </div>
      </div>
    </div>
  );
};
